import { Redirect, Route, useLocation } from 'react-router-dom';
import { isMicroappValid } from 'signup-ui-lego-core/utils/isMicroappValid';
import { getMicroappKey } from '../routing/getMicroappKey';
import { jsx as _jsx } from "react/jsx-runtime";
const MicroappRoute = props => {
  const {
    hash,
    search
  } = useLocation();
  const searchParams = new URLSearchParams(search);
  const microappKey = getMicroappKey();
  if (!isMicroappValid(microappKey)) {
    searchParams.delete('microapp');
    return /*#__PURE__*/_jsx(Redirect, {
      to: {
        pathname: `/`,
        search: searchParams.toString(),
        hash
      }
    });
  }
  return /*#__PURE__*/_jsx(Route, Object.assign({}, props));
};
export default MicroappRoute;